var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChemistry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.599,
    height: 24,
    viewBox: "0 0 18.599 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chemistry",
    transform: "translate(-2.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10835",
    "data-name": "Group 10835"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23500",
    "data-name": "Rectangle 23500",
    width: 14,
    height: 4,
    rx: 1,
    transform: "translate(5)",
    fill: "#eef8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6853",
    "data-name": "Path 6853",
    d: "M16,12.649V5H14v8a1,1,0,0,0,.219.625L16.919,17H7.081l2.7-3.375A1,1,0,0,0,10,13V5H8v7.649L3.469,18.313A3.5,3.5,0,0,0,6.2,24H17.8a3.5,3.5,0,0,0,2.733-5.687Z",
    fill: "#eef8ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemistry);
export default __webpack_public_path__ + "static/media/chemistry.75e748ccf2bab380a779b4fd2f5a5afe.svg";
export { ForwardRef as ReactComponent };